import { useState } from 'react';
import classNames from 'classnames';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';

import style from './SupportWidget.module.scss';

import { SupportWidgetTestAttributes } from 'chaika-test-attributes';

import { translate } from '@chaika/i18n/helper';

import { SupportInbox } from './hooks/useSupportInbox';
import { TicketDetail } from './TicketDetail';
import { TicketList } from './TicketList';

interface SupportWidgetProps {
    inbox: SupportInbox;
    isMobile: boolean;
    isLeftMenuOpen?: boolean;
    onClose(): void;
}

export function SupportWidget({ inbox, isMobile, isLeftMenuOpen = false, onClose }: SupportWidgetProps) {
    const [isPointerOver, setIsPointerOver] = useState(false);

    return (
        <section
            className={classNames(style.root, isMobile && style.mobile, isLeftMenuOpen && style.withOpenMenu)}
            data-test={SupportWidgetTestAttributes.Root}
            data-testid={SupportWidgetTestAttributes.Root}
            aria-label={translate('supportTitle')}
            onMouseEnter={() => setIsPointerOver(true)}
            onMouseLeave={() => setIsPointerOver(false)}
        >
            {inbox.selectedTicketId ? (
                <TicketDetail
                    key={inbox.selectedTicketId}
                    ticketId={inbox.selectedTicketId}
                    unreadCount={inbox.selectedTicketUnread}
                    isPointerOver={isPointerOver}
                    onBack={inbox.closeTicket}
                    onClose={onClose}
                />
            ) : (
                <TicketList
                    inbox={inbox}
                    onClose={onClose}
                />
            )}
        </section>
    );
}
